import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import JsonDebug from '../ui-elements/JsonDebug'
import FooterNavButtonFrame from '../ui-elements/FooterNavButtonFrame'
import AddButton from '../formfields/AddButton'
import YellowAlert from '../ui-elements/YellowAlert'
import Card from '../ui-elements/Card'
import RedAlert from '../ui-elements/RedAlert'
import IndividualCategoryValues from './IndividualCategoryValues'
import DeleteButton from '../formfields/DeleteButton'


type Props = {
    categoryId: string
    formFields: ObjectStringKeyAnyValue
    setFormFields: React.Dispatch<React.SetStateAction<any>>
    checkIfNameAlreadyBeenUsed: (...args: any[]) => boolean
    formErrors: ObjectStringKeyAnyValue
    setFormErrors: React.Dispatch<React.SetStateAction<any>>
}

function IndividualCategory({
    categoryId,
    formFields,
    setFormFields,
    checkIfNameAlreadyBeenUsed,
    formErrors,
    setFormErrors
}: Props) {

    const {
        setShowModal
    } = useContext(GlobalContext)


    const [newValueName, setNewValueName] = useState('')

    const updateCategoryName = (categoryId: string, value: string) => {
        const newFormData = { ...formFields, [categoryId]: { ...formFields[categoryId], DisplayName: value } }
        setFormFields(newFormData)
    }

    const deleteCategory = (categoryId: string) => {
        const newFormData = { ...formFields }
        delete newFormData[categoryId]
        setFormFields(newFormData)
    }


    const addValueToCategoryType = () => {
        const newFormData = { ...formFields }
        const newFormErrors = { ...formErrors }
        if (newFormData[categoryId]) {
            const newId = `cv-${Date.now()}-${Math.floor(Math.random() * 1000)}`
            const hasNameAlreadyBeenUsed = checkIfNameAlreadyBeenUsed(newValueName, null, newFormData[categoryId]['Values'])
            if (hasNameAlreadyBeenUsed) {
                newFormErrors[`${categoryId}-Values`] = `Value "${newValueName}" already exists in category ${categoryId}`
            } else {
                newFormData[categoryId]['Values'] = { ...newFormData[categoryId]['Values'] }
                newFormData[categoryId]['Values'][newId] = {
                    DisplayName: newValueName
                }
                setFormFields(newFormData)
                setNewValueName('')
            }
        } else {
            console.error(`Category ${categoryId} not found in formFields`)
        }
        setFormErrors(newFormErrors)
    }




    return <Card fullwidth={true}>
        <div className={`flex flex-col gap-4`}>
            <div className={`flex flex-col gap-4`}>
                {/* <p className={`text-xs italic text-gray-500`}>{categoryId}</p> */}

                <div className={`flex flex-col gap-2`}>
                    <p className={`font-bold`}>Category name:</p>
                    <input
                        className={`text-sm px-3 py-2 bg-gray-200 border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full`}
                        type='text'
                        name={`DisplayName`}
                        value={formFields[categoryId] && formFields[categoryId]['DisplayName'] || ''}
                        onChange={(e) => updateCategoryName(categoryId, e.target.value)}
                    />

                    {formErrors[`${categoryId}-DisplayName`] && <RedAlert>{formErrors[`${categoryId}-DisplayName`]}</RedAlert>}
                </div>

                <div className={`flex flex-col gap-2`}>
                    <p className={`font-bold`}>Category values:</p>



                    <div className={`flex flex-row gap-2`}>
                        <input
                            className={`text-sm px-3 py-2 bg-gray-200 border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full`}
                            type='text'
                            name={`NewValueName`}
                            value={newValueName || ''}
                            onChange={(e) => setNewValueName(e.target.value)}
                        />
                        <Button
                            text={`Add`}
                            onClick={addValueToCategoryType}
                            variant={newValueName.length === 0 ? 'gray' : `primary`}
                            fullwidth={false}
                            disabled={newValueName.length === 0}

                        />
                    </div>
                    {formFields[categoryId]['Values'] && Object.keys(formFields[categoryId]['Values']).length > 0 &&
                        <div className={`flex flex-row flex-wrap gap-2`}>
                            {Object.keys(formFields[categoryId]['Values']).map((categoryValueId, index) => {
                                return <IndividualCategoryValues
                                    key={index}
                                    categoryId={categoryId}
                                    categoryValueId={categoryValueId}
                                    formFields={formFields}
                                    setFormFields={setFormFields}
                                />
                            })}</div>}
                    {formErrors[`${categoryId}-Values`] && <RedAlert>{formErrors[`${categoryId}-Values`]}</RedAlert>}
                </div>

            </div>


            <DeleteButton
                deleteFunction={deleteCategory}
                functionParams={categoryId}
                variant='x-icon'
                modalText='Are you sure you want to delete this category?'
            />
        </div>
    </Card >
}
export default IndividualCategory